var obj = {
	init: function(){
		obj.sliderNews();
		obj.navSidebar();
		obj.navMobile();
		obj.tooltip();
		obj.sliderHome();
		obj.features();
		obj.blockGallery();
		obj.scrollBarU();
		obj.sliderGuia();
		obj.searchPicker();
		obj.selectCustom();
		obj.mapUnacem();
		obj.palabrasClaves();
		obj.fileUpload();
	},
	navMobile: function(){
		$('.l-bread').on('click', function() {
          	$(this).parent().toggleClass('open');
          	/*if ($('#overlay').length) {
              	$('#overlay').remove();
              	$('body').removeClass('overlay');
          	} else {
              	$('body').append($overlay);
              	$('body').addClass('overlay');
          	}*/
          	var $this = this;
          	setTimeout(function() {
              	$($this).parent().toggleClass('closing');
          	}, 500);
      	}); 
      	$('.close-nav').on('click', function() {
      		$(".inner-header").removeClass("open");
      		$(".inner-header").removeClass("closing");
      	});

      	$(".active--sub").click(function(e){
      		e.preventDefault();
      		$(this).parent().find(".sub--nav--l").css('left', '0');
      		var alturaSub = $(this).parent().find(".sub--nav--l").height();
      		$(this).parent().parent().parent().css('height', alturaSub + 10);
      	});

      	$(".sub--nav--l>span").click(function(){
      		$(this).parent().parent().parent().parent().css('height', 'auto');
      		$(this).parent().css('left', '-100%');
      	});

      	$(".sub---nav---ul").click(function(e){
      		e.preventDefault();
      		if($(this).hasClass("active--sub--list")){
      			$(this).removeClass("active--sub--list");
      			var alturaSubSub = $(this).parent().find("ul").height();
      			console.log(alturaSubSub);
      			$(this).parent().find("ul").hide();
      			var $this = this;
	      		setTimeout(function() {
	      			var alturaSub = $($this).parent().parent().parent().parent().parent().parent().parent().height();
	      			$($this).parent().parent().parent().parent().parent().parent().css('height', alturaSub - alturaSubSub);
	      		}, 100);
      		}else{
	      		$(this).addClass("active--sub--list");
	      		$(this).parent().find("ul").show();
	      		var $this = this;
	      		setTimeout(function() {
	      			var alturaSubSub = $($this).parent().find("ul").height();
	      			var alturaSub = $($this).parent().parent().parent().parent().parent().parent().parent().height();
	      			$($this).parent().parent().parent().parent().parent().parent().css('height', alturaSub + alturaSubSub + 15);
	      		}, 100);
      		}
      	});
	},
	fileUpload: function(){
		$('#inputGroupFile01').on('change',function(){
            var fieldVal = $(this).val();
	        fieldVal = fieldVal.replace("C:\\fakepath\\", "");

	        if (fieldVal != undefined || fieldVal != "") {
	            $(this).next(".custom-file-label").attr('data-content', fieldVal);
	            $(this).next(".custom-file-label").text(fieldVal);
	        }
        })
	},
	navSidebar: function(){
		$("#menu").accordion();
	},
	sliderHome: function(){
	    if($(".slider-home").length){
	      	$('.slider-home').slick({
		        arrows: true,
		        dots: true,
		        infinite: true,
		        autoplay: true,
		        autoplaySpeed: 4000,
		        fade: true,
		        cssEase: 'linear',
		        prevArrow: $('.arrow-prev-c'),
				nextArrow: $('.arrow-next-c')
	    	});
	  	}
	},
	features: function(){
		if($(".block-features").length){
			//Nuevos documentos
			$('.slider-sub-one').slick({
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        infinite: false,
		        prevArrow: $('.arrow-1-prev'),
		        nextArrow: $('.arrow-1-next'),
		        dots: true
		    });
			//Proximos eventos
		    $('.slider-sub-two').slick({
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        infinite: false,
		        prevArrow: $('.arrow-2-prev'),
		        nextArrow: $('.arrow-2-next'),
		        dots: true
		    });
		    //Novedades tecnicas
		    $('.slider-sub-three').slick({
		        slidesToShow: 1,
		        slidesToScroll: 1,
		        infinite: false,
		        prevArrow: $('.arrow-3-prev'),
		        nextArrow: $('.arrow-3-next'),
		        dots: true
		    });

			$(".slider-features").slick({
				prevArrow: '.arrow-d-prev',
		       	nextArrow: '.arrow-d-next'
			});
			var newWidth = $(window).width();
			if (newWidth > 992) {
				$('.slider-features').slick("unslick");
			}else{
				$('.slider-features').not('.slick-initialized').slick({
			        slidesToShow: 1,
		        	slidesToScroll: 1,
			        prevArrow: '.arrow-d-prev',
		        	nextArrow: '.arrow-d-next'
			    });
			}
			$(window).resize(function(){
			    var $windowWidth = $(window).width();
			    if ($windowWidth > 992) {
			     	$('.slider-features').slick("unslick");
			    }else{
			    	$('.slider-features').not('.slick-initialized').slick({
				        slidesToShow: 1,
		        		slidesToScroll: 1,
				        prevArrow: '.arrow-d-prev',
		        		nextArrow: '.arrow-d-next'
				    });
			    }
			});
		}
	},
	tooltip: function(){
		$('[data-toggle="tooltip"]').tooltip();
	},
	sliderNews: function(){
		if($(".slider-news").length){
			$(".slider-news").slick({
				prevArrow: '.news-prev',
		       	nextArrow: '.news-next'
			});
			var newWidth = $(window).width();
			if (newWidth > 992) {
				$('.slider-news').slick("unslick");
			}else{
				$('.slider-news').not('.slick-initialized').slick({
			        slidesToShow: 1,
		        	slidesToScroll: 1,
			        prevArrow: '.news-prev',
		        	nextArrow: '.news-next'
			    });
			}
			$(window).resize(function(){
			    var $windowWidth = $(window).width();
			    if ($windowWidth > 992) {
			     	$('.slider-news').slick("unslick");
			    }else{
			    	$('.slider-news').not('.slick-initialized').slick({
				        slidesToShow: 1,
		        		slidesToScroll: 1,
				        prevArrow: '.news-prev',
		        		nextArrow: '.news-next'
				    });
			    }
			});
		}
	},
	blockGallery: function(){
		if($(".block-slider-gallery").length){

			var $carouselGallery = $('.slider-gallery');

			$carouselGallery.slick({
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 5,
				slidesToScroll: 1,
				responsive: [
				    {
				      	breakpoint: 992,
				      	settings: {
				        	slidesToShow: 4,
				        	slidesToScroll: 1
				      	}
				    },
				    {
				      	breakpoint: 768,
				      	settings: {
				        	slidesToShow: 3,
				        	slidesToScroll: 1
				      	}
				    },
				    {
				      	breakpoint: 468,
				      	settings: {
				        	slidesToShow: 2,
				        	slidesToScroll: 1
				      	}
				    }
				]
			});

			$carouselGallery.find(".slick-slide").click(function(){
		    	$carouselGallery.find(".slick-slide").removeClass("gallery-active-unacem");
		    	$(this).addClass("gallery-active-unacem");
		    });

			$carouselGallery.magnificPopup({
	            type: 'image',
	            delegate: 'a',
	            tLoading: 'Cargando imagen #%curr%...',
		        mainClass: 'mfp-img-mobile',
	            gallery: {
	                enabled: true,
			        navigateByImgClick: true,
			        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	            }
        	});
		}
	},
	scrollBarU: function(){
		if($(".b-scroll-bar").length){
			$(".b-scroll-bar").scrollBox();
		}
	},
	sliderGuia: function(){
		if($(".block-slider-guide").length){
			var sliderGuide = $('.slider-guide');
			var contentGuide = $("#slider-content-guide");

			sliderGuide.on('init', function(event, slick){
				$(".slider-guide").find(".slick-current").addClass("slick-active-unacem");
		        //var dataSlider = sliderGuide.find(".slick-slide.slick-current .data-guide").html();
		        //contentGuide.html(dataSlider);
		    });
			sliderGuide.slick({
				dots: false,
				infinite: false,
				speed: 300,
				slidesToShow: 6,
				slidesToScroll: 1,
				responsive: [
					{
				      	breakpoint: 1200,
				      	settings: {
				        	slidesToShow: 5,
				        	slidesToScroll: 1
				      	}
				    },
				    {
				      	breakpoint: 992,
				      	settings: {
				        	slidesToShow: 4,
				        	slidesToScroll: 1
				      	}
				    },
				    {
				      	breakpoint: 768,
				      	settings: {
				        	slidesToShow: 3,
				        	slidesToScroll: 1
				      	}
				    },
				    {
				      	breakpoint: 468,
				      	settings: {
				        	slidesToShow: 2,
				        	slidesToScroll: 1
				      	}
				    }
				]
			});
		    sliderGuide.on('afterChange', function(event, slick, currentSlide, nextSlide){
		        //var dataSlider = sliderGuide.find(".slick-slide.slick-current .data-guide").html();
		        //contentGuide.html(dataSlider);
		    });

		    sliderGuide.find(".slick-slide").click(function(){
		    	$(".slider-guide").find(".slick-slide").removeClass("slick-active-unacem");
		    	$(this).addClass("slick-active-unacem");
		    	var dataSlider = $(this).find(".item-guide").find(".data-guide").html();
		    	contentGuide.html(dataSlider);
		    });
		}
	},
	searchPicker: function(){
		if($(".filter-fech").length){
			var startDate = $('.start-date');
	      	var endDate = $('.end-date');

	      	startDate.datepicker({
	        	autoHide: true,
	        	language: 'es-ES',
	        	format: 'dd/mm/yyyy'
	      	});

	      	endDate.datepicker({
	        	autoHide: true,
	        	language: 'es-ES',
	        	format: 'dd/mm/yyyy',
	        	startDate: startDate.datepicker('getDate'),
	      	});

	      	startDate.on('change', function () {
	        	endDate.datepicker('setStartDate', startDate.datepicker('getDate'));
	      	});
		}
	},
	selectCustom: function(){
		if($(".select-custom").length){
			$('.select-custom').customSelect();
		}
	},
	palabrasClaves: function(){
        $("#button-sector").on('click', function() {
            if ($('#overlay').length) {
                $('#overlay').remove();
            } else {
                $('body').append('<div id="overlay"></div>');
            }
            $('.portafolio-sidebar-sector').toggleClass('portafolio-sidebar-sector-active');
        });
    
        $("#apply-sector-filters").on('click', function() {
            $('#overlay').remove();
            $('.portafolio-sidebar-sector').removeClass('portafolio-sidebar-sector-active');
    
            var cfilters = [];
            $("#menu-filter-sector input[type=checkbox]").each(function() {
                this.checked ? cfilters.push({value: $(this).val(), label: $(this).attr('data-label')}) : '';
            });
            
            cfilters.forEach(function (e) {
                if (!$('.portafolio-tags a[data-filter="' + e.value + '"]').length) {
                    $('.portafolio-tags').append('<a data-type="sector" data-filter="' + e.value + '" href="#">' + e.label + '</a>')
                }
            });
    
        });
    
        $('.portafolio-tags').on('click', 'a', function(e) {
            e.preventDefault();
            var type = $(this).attr('data-type');
            if (type === "sector") {
                var tag = $(this).attr('data-filter');
                $("#filter-tag-" + tag).prop("checked", false);
            }
            //- else if (type === "incharge") {
            //-     $("input[type=radio][name=proyectosEncargados]").prop("checked", false);
            //- }
            $(this).remove();
        });
	},
	mapUnacem: function(){
		if($("#map").length){
			var latU = $("#map").data("lat");
			var logU = $("#map").data("log");
			function initialize() {
		        var bangalore = { lat: latU, lng: logU };
		        var map = new google.maps.Map(document.getElementById('map'), {
		          	zoom: 12,
		          	center: bangalore
		        });

		        // This event listener calls addMarker() when the map is clicked.
		        google.maps.event.addListener(map, 'click', function(event) {
		          	addMarker(event.latLng, map);
		        });

		        // Add a marker at the center of the map.
		        addMarker(bangalore, map);
		    }

		    // Adds a marker to the map.
		    function addMarker(location, map) {
		        // Add the marker at the clicked location, and add the next-available label
		        // from the array of alphabetical characters.
		        var marker = new google.maps.Marker({
		          	position: location,
		          	map: map
		        });
		    }

		    google.maps.event.addDomListener(window, 'load', initialize);
		}
	}
}

$(function() {
	obj.init();
});
